import { format, parse } from 'date-fns';
import daLocale from 'date-fns/locale/da';

const DK_DATE_FORMAT = 'd. MMMM yyyy';
const ISO_DATE_FORMAT = 'yyyy-MM-dd';
const SHORT_DK_DATE_FORMAT = 'dd-MM-yyyy';

// Format date according to Topdanmark guidelines, example: '17. december 2020'
export const dkDateFormat = (date: Date): string => {
    return format(date, DK_DATE_FORMAT, { locale: daLocale });
};

// Format date as short ISO format: yyyy-mm-dd
export const isoDateFormat = (date: Date): string => {
    return format(date, ISO_DATE_FORMAT);
};

// Format date as short dk format: dd-mm-yyyy
export function shortDkDateFormat(date: Date): string {
    return format(date, SHORT_DK_DATE_FORMAT);
}

// Parse dateString as dk format (dd-mm-yyyy), return Date
export function parseShortDkDateFormat(dateString: string): Date {
    return parse(dateString, SHORT_DK_DATE_FORMAT, 0);
}

// Parse dateString as iso format (yyyy-mm-dd), return Date
// Notice that we do not support the full ISO8601 spec, only the date part in
// the most simple form. If you need more than that, consider parseIso from date-fns.
export function parseIsoDateFormat(dateString: string): Date {
    return parse(dateString, ISO_DATE_FORMAT, 0);
}

// Convert dateString in dk format (dd-mm-yyyy) to short ISO format (yyyy-mm-dd)
export function convertDkDateToIsoDate(dateString: string): string {
    const d = parseShortDkDateFormat(dateString);
    return isoDateFormat(d);
}

// Converts dateString in iso format (yyyy-mm-dd) to dk format
export function convertIsoDateToDkDate(date: string): string {
    const d = parseIsoDateFormat(date);
    return dkDateFormat(d);
}
